import * as React from 'react';
import { SERVICE_NAMES } from './constants';
import * as styles from './PackagesTitle.css';

interface IPackagesTitleProps {
  serviceId: string;
}

export const PackagesTitle = ({ serviceId }: IPackagesTitleProps) => {
  return <div className={styles['header']}>Ваши пакеты {SERVICE_NAMES[serviceId]}</div>;
};
